export default __webpack_public_path__ + "static/media/meetra_long.c7f118bb.png";